// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"086b0dd4840d7334d722","303":"f4ff39074b5541c94b08","495":"6aa694ba4d34632624ae"}[chunkId] + ".js";
};